module.exports = vendor_library;


//////////////////
// WEBPACK FOOTER
// external "vendor_library"
// module id = 49fU
// module chunks = 174